import React, { useState, useEffect } from 'react';
import { Row } from 'antd';
import { FormattedMessage } from 'react-intl';
import { CloseOutlined } from '@ant-design/icons';

import Button from 'atoms/Button';
import InfoIcon from 'atoms/InfoIcon';
import {
  FORM_NAME,
} from 'utils/constants';
import Card from 'atoms/Card';
import Input from 'atoms/Input';
import { Form, CardWrapper } from './AntStyled';

export default function (props) {
  const { completeTask, closeModal } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const onFinish = ({ completionHours }) => {
    setLoading(true);
    completeTask(completionHours).then(() => {
      setLoading(false);
      form.resetFields();
    }).catch((e) => {
      setLoading(false);
      console.log(e);
    });
  };
  return (
    <CardWrapper>
      <Card
        padding="30px 20"
        title={(
          <Row justify="space-between" align="middle">
            <InfoIcon title={<FormattedMessage id="me.spent" />} className="small-fonts" />
            <CloseOutlined onClick={closeModal} />
          </Row>
        )}
      >
        <Form
          form={form}
          layout={FORM_NAME.VERTICAL}
          onFinish={onFinish}
        >
          <Form.Item
            label={<FormattedMessage id="me.formRules.spent.label" />}
            name="completionHours"
            rules={[
              { pattern: /^\d{1,2}(\.\d{1,2})?$/, message: <FormattedMessage id="me.formRules.estimation.hoursPattern" /> },
            ]}
          >
            <Input allowClear autoFocus autoComplete="off" />
          </Form.Item>
          <Button
            htmlType="submit"
            name={<FormattedMessage id="me.save" />}
            loading={loading}
          />
        </Form>
      </Card>
    </CardWrapper>

  );
}
